import namespace from "@rdf-esm/namespace";
const builder = namespace("http://purl.org/linked-data/cube#");
export const strict = builder;
export const loose = builder;